import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
import { routes as routesViews } from '@/views'
import { requestSwUpdate } from '@/registerServiceWorker'

Vue.use(Router)

const routes = [...routesViews]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(beforeEach)
router.afterEach(() => {
  requestSwUpdate('- Página foi recarregada')
})

export default router
